import { render } from "./FormChecksRadiosPage.vue?vue&type=template&id=58f388a6&ts=true"
import script from "./FormChecksRadiosPage.vue?vue&type=script&lang=ts"
export * from "./FormChecksRadiosPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__